import React from 'react';

import ErrorIcon from '@atlaskit/icon/core/migration/status-error--error';
import SuccessIcon from '@atlaskit/icon/core/migration/status-success--check-circle';
import WarningIcon from '@atlaskit/icon/core/migration/status-warning--warning';
import { token } from '@atlaskit/tokens';

import type { FlagType } from './types';

export const flagIconByType: Partial<Record<FlagType, JSX.Element>> = {
	error: <ErrorIcon spacing="spacious" label="" color={token('color.icon.danger')} />,
	warning: <WarningIcon spacing="spacious" label="" color={token('color.icon.warning')} />,
};

export const getTypeIcon = (type: FlagType = 'normal'): JSX.Element =>
	flagIconByType[type] || (
		<SuccessIcon spacing="spacious" label="" color={token('color.icon.success')} />
	);
